import type { ReactElement } from "react";
import { ActionIcon, Text } from "@mantine/core";
import { useMantineTextColorIndex } from "hooks/useMantineTextColor";
import "./styles.css";
import choiceClasses from "components/UI/ChoiceActionIcon.module.css";
import classes from "./ActionIconSelect.module.css";

interface ActionIconSelectItem<T> {
  icon: ReactElement;
  value: T;
}

export const ActionIconSelect = <T extends string>({
  items,
  label,
  onItemClick,
  value: selectedValue,
}: {
  items: ActionIconSelectItem<T>[];
  label: string;
  onItemClick: (value: T) => void;
  value: T;
}) => {
  const textColor = useMantineTextColorIndex();

  return (
    <div className="trkbk-context-menu sub-menu-item-action-icon-select">
      <>
        <Text className={`label ${classes.label}`}>{label}</Text>
        {items.map(({ icon, value }) => {
          const isSelected = value === selectedValue;

          return (
            <ActionIcon
              className={`action-icon ${choiceClasses.choice}`}
              mod={{ selected: isSelected }}
              key={value}
              onClick={() => {
                onItemClick(value);
              }}
              size={28}
              variant={isSelected ? "filled" : "transparent"}
              c={isSelected ? "white" : textColor}
            >
              <div className="icon">{icon}</div>
            </ActionIcon>
          );
        })}
      </>
    </div>
  );
};
